export const normalizePath = (href?: string) => href?.split('?')[0] ?? '';

export const isPathMatching = (href: string | undefined, pathname: string) => {
  const path = normalizePath(href);
  if (!path) return false;
  if (path === '/') return pathname === '/';
  return pathname === path || pathname.startsWith(`${path}/`);
};
